export const CONFIG = {
  logo: "/logo.png",
  site_title: "NBIoT Management",
  Auth0Domain: "nbiot.uk.auth0.com",
  Auth0ClientId: "ToUdg63aOdyBM6IK4a301A6OtdLMw115",
  Auth0Audience: "https://management.api.nbiot.co.uk",
  API_URL: "https://management-api.nbiot.co.uk/",
  mapboxAccessToken:
    "pk.eyJ1IjoiYmZnbmVpbCIsImEiOiJjbGR2azExeW4wZ28yM29tZm4xZjJwdHFxIn0.Mdv--BkZwKSw-pdTRMQdPg",
  mapStyle: "mapbox://styles/bfgneil/clkha3odl008i01qpeqws6d21",
  websiteURL: "https://management.nbiot.co.uk",
  billingEnabled: false,
  deviceCost: 15,
  primaryColour: "#009bd6",
  secondaryColour: "#00415a",
};
